import {instance, onErrorFunction, onSuccessFunction} from "../../../config/axios-cnf";

const url = (subjectId) => "/api/v2/enigoo/" + subjectId + "/user"

export const apiGetUser = (subjectId, id = null, callback, error) => {
    instance.get(url(subjectId) + (id ? "/" + id : ""))
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiPostCreateUser = (subjectId, data, callback, error) => {
    instance.post(url(subjectId), data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiPutUpdateUser = (subjectId, id, data, callback, error) => {
    instance.put(url(subjectId) + "/" + id, data)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}

export const apiDeleteUser = (subjectId, id, callback, error) => {
    instance.delete(url(subjectId) + "/" + id)
        .then((response) => callback(onSuccessFunction(response.data)))
        .catch((err) => error(onErrorFunction(err)));
}
